import PropTypes from "prop-types";
import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { cancelAppointment } from "../utils/fetcher";
import { translator } from "../utils/i18n";

export default function ConfirmCancelAppointment(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const cancelAppointmentFunc = () => dispatch(cancelAppointment());

  const cancelFunc = () => {
    cancelAppointmentFunc();
    props.action();
    props.toggleDialog(false);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.isOpenDialog}
      onClose={() => props.toggleDialog(false)}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        {translator()._("W_ATTENTION_RDV_NON_CONFIRME")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {translator()._("W_FINIR_PROCESSUS")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={cancelFunc} color="primary">
          {translator()._("W_ANNULER_RDV")}
        </Button>
        <Button
          onClick={() => props.toggleDialog(false)}
          color="primary"
          autoFocus
        >
          {translator()._("W_CONFIRMER_RDV")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmCancelAppointment.propTypes = {
  action: PropTypes.func,
  isOpenDialog: PropTypes.bool,
  toggleDialog: PropTypes.func
};
